import reorderAll from 'utils/reorderAll'

interface getReorderRowsProps {
  sortRowsUrl: string
  data: Array<any>
}

const reorderRows = async (props: getReorderRowsProps): Promise<Array<any>> => {
  const data = await reorderAll(props.sortRowsUrl, props.data)

  return data
}

export default reorderRows
